import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu_icons/Cereri_si_Oferte.png'
import _imports_1 from '@/assets/PDF_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-b162dd0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__color--label q-ma-md"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","zoom":"0.8","margin-right":"4px"}
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "app__label--medium app__color--semigray",
  style: {"padding-top":"5rem"}
}
const _hoisted_7 = { class: "first_line" }
const _hoisted_8 = {
  class: "app__property--medium",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_9 = {
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_10 = { class: "second_line" }
const _hoisted_11 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_12 = { style: {"min-width":"2rem"} }
const _hoisted_13 = {
  class: "app__property--medium",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_14 = {
  key: 0,
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_15 = {
  key: 1,
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_16 = { style: {"padding-left":"2rem","display":"flex","align-items":"start"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"36px","height":"36px"}
}, null, -1))
const _hoisted_18 = {
  key: 1,
  style: {"display":"flex","flex-direction":"row","width":"20rem","overflow-x":"auto","padding-left":"0rem"}
}
const _hoisted_19 = { style: {"text-align":"center","display":"flex","flex-direction":"row","align-items":"center","justify-content":"center"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"36px","height":"36px"}
}, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "shopping_cart__container--btns btns_line"
}
const _hoisted_22 = {
  key: 2,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_23 = {
  key: 3,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 120px)","top":"10px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, { style: {"cursor":"pointer"} }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.requests_and_offers')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.offersHeaders.length >300)
        ? (_openBlock(), _createBlock(_component_q_input, {
            key: 1,
            "bottom-slots": "",
            modelValue: _ctx.inputSearchOffer,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputSearchOffer) = $event)),
            dense: "",
            style: {"margin-left":"auto"}
          }, {
            append: _withCtx(() => [
              (_ctx.inputSearchOffer !== '')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputSearchOffer = '')),
                    class: "cursor-pointer"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_icon, { name: "search" })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.offersHeaders.length ==0 && !_ctx.loadingOffers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('message.no_offers')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offersHeaders, (offer) => {
        return (_openBlock(), _createElementBlock("div", {
          key: offer.offerId,
          class: _normalizeClass(["offer_div", { 'is--deleting': (offer.offerId==_ctx.appidToBeDeleted) }])
        }, [
          (offer.offerId==_ctx.appidToBeCancelled || offer.offerId==_ctx.appidToBeRecalled)
            ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                key: 0,
                indeterminate: "",
                color: "secondary",
                style: {"position":"absolute"}
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.request_id')) + " " + _toDisplayString(offer.offerId), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(offer.trackCreationDate), 1)
            ]),
            _createVNode(_component_q_btn, {
              style: {"background-color":"#9b7d32","color":"white"},
              size: "sm",
              "no-caps": "",
              label: _ctx.$t('message.request_details'),
              onClick: ($event: any) => (_ctx.onOpenCerere(offer.offerId, offer.trackCreationDate))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10],
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.open_request')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["label", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (offer.offerSlid && offer.status=='o')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      name: "check_circle_outline",
                      class: "text-blue",
                      style: {"font-size":"1.5rem"}
                    }))
                  : _createCommentVNode("", true),
                (offer.offerSlid && offer.status=='k')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      name: "check_circle_outline",
                      class: "text-green",
                      style: {"font-size":"1.5rem"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.humanStatusOffer(offer.status)), 1),
                (offer.offerSlid && offer.status=='o')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(offer.trackDateOfertare), 1))
                  : _createCommentVNode("", true),
                (offer.offerSlid && offer.status=='k')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(offer.trackDateAccept), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (offer.status!='p')
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    "no-caps": "",
                    size: "sm",
                    onClick: ($event: any) => (_ctx.generareOferta(offer.offerId, 0)),
                    flat: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.open_offer')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (offer.reoffers_count > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(offer.reoffers_count-1, (index) => {
                      return (_openBlock(), _createBlock(_component_q_btn, {
                        key: index,
                        "no-caps": "",
                        size: "sm",
                        onClick: ($event: any) => (_ctx.generareOferta(offer.offerId, index)),
                        flat: "",
                        style: {"display":"flex","align-items":"center","justify-content":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", null, _toDisplayString(index) + "  ", 1),
                            _hoisted_20,
                            _createVNode(_component_q_tooltip, {
                              anchor: "top middle",
                              self: "bottom middle",
                              offset: [10, 10],
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.open_offer')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.user.tip != '3' )
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (offer.status == 'o' || offer.status == 'm')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      style: {"cursor":"pointer","font-size":"1.5rem","margin-right":"2rem","background-color":"#9b7d32","color":"white"},
                      name: "rule",
                      onClick: ($event: any) => (_ctx.acceptOffer(offer.offerId))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [10, 10],
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.accept_request')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (offer.status == 'o')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      style: {"cursor":"pointer","font-size":"1.5rem","margin-right":"2rem","background-color":"#9b7d32","color":"white"},
                      name: "edit_note",
                      onClick: ($event: any) => (_ctx.modifyOffer(offer.offerId))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [10, 10],
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.modify_offer')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (offer.status!='k')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 2,
                      style: {"cursor":"pointer","font-size":"1.5rem","color":"red"},
                      name: "delete_forever",
                      onClick: ($event: any) => (_ctx.askCancelOffer(offer.offerId))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [10, 10],
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.cancel_request')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogViewOferta,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogViewOferta) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, {
              class: _normalizeClass({ 'bg-blue-grey-11': _ctx.$q.platform.is.desktop , 'bg-white': _ctx.$q.platform.is.mobile })
            }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      icon: "arrow_back",
                      color: "black",
                      size: "md",
                      onClick: _ctx.closeCurrentView
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      name: "arrow_back_ios",
                      class: "app__arrow--back",
                      onClick: _ctx.closeCurrentView
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.dynamicComponentTitle) + " " + _toDisplayString(_ctx.selectedOfferSlid) + " / " + _toDisplayString(_ctx.selectedOfferDate), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.dynamicComponentTitle) + " " + _toDisplayString(_ctx.selectedOfferSlid) + " / " + _toDisplayString(_ctx.selectedOfferDate), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 4,
                      dense: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), {
                  propOfferId: _ctx.selectedOfferId,
                  closeHandler: _ctx.closeFormViewOferta
                }, null, 8, ["propOfferId", "closeHandler"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.fixed,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fixed) = $event)),
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      "no-caps": "",
                      color: "#273233",
                      onClick: _ctx.downloadPDF,
                      icon: "download",
                      style: {"margin-left":"1rem","cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.download")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      "no-caps": "",
                      flat: "",
                      color: "#273233",
                      icon: "download",
                      onClick: _ctx.downloadPDF,
                      style: {"cursor":"pointer"}
                    }, null, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(_component_q_space),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 2,
                      color: "black",
                      size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                    }, null, 8, ["size"]))
                  : _createCommentVNode("", true),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 5,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.widthPdf=300))
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
              ]),
              _: 1
            }),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                          icon: "zoom_in",
                          style: {"margin-bottom":"8px"}
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                          icon: "zoom_out",
                          style: {"margin-left":"10px","margin-bottom":"8px"}
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_24,
                    _createVNode(_component_vue_pdf_embed, {
                      source: _ctx.pdf,
                      width: _ctx.widthPdf
                    }, null, 8, ["source", "width"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_pdf_embed, { source: _ctx.pdf }, null, 8, ["source"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreCertificates,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.areMoreCertificates) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card_5" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (certificat, index) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: certificat.ItemNo
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.item_no')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(certificat.ItemNo), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _hoisted_25,
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.description')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(certificat.Description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "#273233",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => (_ctx.download_certificate_2(index))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.item_no')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(certificat.ItemNo), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.description')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(certificat.Description), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 3,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "#273233",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => (_ctx.download_certificate_2(index))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreInvoices,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.areMoreInvoices) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'my_card_5' : 'my_card_6')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoices, (invoice) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: invoice.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.invoice')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(invoice.id), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "#273233",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => (_ctx.download_invoice(invoice.id))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.invoice')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(invoice.id), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "#273233",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => (_ctx.download_invoice(invoice.id))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreInvoicesCertificate,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.areMoreInvoicesCertificate) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'my_card_5' : 'my_card_6')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, "Certificate Oferta " + _toDisplayString(_ctx.selectedOfferSlid), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoices, (invoice) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: invoice.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.certificates')) + " " + _toDisplayString(_ctx.$t('message.invoice')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(invoice.id), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "#273233",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => (_ctx.download_certificate(invoice.id))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.certificates')) + " " + _toDisplayString(_ctx.$t('message.invoice')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(invoice.id), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "#273233",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => (_ctx.download_certificate(invoice.id))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.prompt,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.prompt) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('message.modify_offer')) + " " + _toDisplayString(_ctx.selectedOfferId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  dense: "",
                  modelValue: _ctx.modifiedOfferText,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modifiedOfferText) = $event)),
                  autofocus: "",
                  maxlength: "1000",
                  type: "textarea",
                  autogrow: "",
                  counter: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "text-primary"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$t('message.close')
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$t('message.send'),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendModifyOffer(_ctx.selectedOfferId)))
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}